import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import React from 'react';

import { useRouter } from 'common/hooks';
import AppRoutesEnum from 'common/routes/AppRoutes.enum';
import MenuItemButton from './MenuItemButton';

const ExportApiTokensMenuItem: React.FC = () => {
  const { goTo } = useRouter();

  return (
    <MenuItemButton
      onClick={() => goTo(AppRoutesEnum.ADMIN_EXPORT_API_TOKENS_ROOT)}
      label="Export API Tokens"
    >
      <KeyOutlinedIcon />
    </MenuItemButton>
  );
};

export default ExportApiTokensMenuItem;
